import { useLocale } from '@solinkcorp/locale';
import { cn } from '@solinkcorp/solink-ui';

interface ScheduleConflictHelperTextProps {
  layoutNames: string[];
  className?: string;
}

/**
 * Helper text shown when an updated day part schedule conflicts with thresholds
 * on widgets in one or more layouts. Renders below inactive days. Not part of RHF.
 */
export function ScheduleConflictHelperText({
  layoutNames,
  className,
}: ScheduleConflictHelperTextProps) {
  const locale = useLocale();
  const message = locale.serviceDisplayMonitor.dayPartDialog?.scheduleOverlapsLayoutsHelper;

  if (layoutNames.length === 0) return null;

  const text =
    message?.replace('{layoutNames}', layoutNames.join(', ')) ??
    `Updated day part schedule conflicts with thresholds that exist on widgets in the following layout(s): ${layoutNames.join(', ')}.`;

  return (
    <p
      className={cn('pt-1 text-destructive caption', className)}
      role="alert"
      data-schedule-conflict-helper
    >
      {text}
    </p>
  );
}
